// Create the i18n instance
import { createI18n } from 'vue-i18n';

// Import translations
import en from '../locales/en.json';

const i18n = createI18n({
  legacy: false,
  locale: 'en',
  fallbackLocale: 'en',
  messages: { en },
});

export default i18n;
